/// <reference path="../htmleditor/htmleditor.ts" />

namespace OfficeGuy.Apps {
    export class LandingPages {
        static InitEditor(PageID: number = 0) {
            HTMLEditor.WidgetsDefinitions = LandingPages.ListWidgetsDefinitions();
            HTMLEditor.TemplateParameters = LandingPages.ListTemplateParameters();
            if (PageID == 0)
                HTMLEditor.UploadImageURL = null;
            else
                HTMLEditor.UploadImageURL = "/landingpages/uploadimage/?pageid=" + PageID;
            HTMLEditor.Function_CreateWidgetByName = LandingPages.CreateWidgetByName;
            HTMLEditor.IsEmailEditor = false;
            HTMLEditor.InitEditor();
        }

        static ParametersGroup_Background(Parameters: Array<HTMLEditor_Parameter>, Category: string, Prefix: string, DefaultBackgroundColor: string) {
            Parameters.push(new HTMLEditor_Parameter(Category, "צבע רקע", Prefix + "BackgroundColor", "BackgroundColor", DefaultBackgroundColor));
            Parameters.push(new HTMLEditor_Parameter(Category, "תמונת רקע", Prefix + "BackgroundImage", "BackgroundImage", ""));
            Parameters.push(new HTMLEditor_Parameter(Category, "פריסת תמונת רקע", Prefix + "BackgroundSize", "BackgroundSize", ""));
        }
        static ParametersGroupNames_Background(Prefix) {
            return Prefix + "BackgroundColor," + Prefix + "BackgroundImage," + Prefix + "BackgroundSize";
        }

        static ParametersGroup_Text(Parameters: Array<HTMLEditor_Parameter>, Category: string, Prefix: string, DefaultFontFamily: string, DefaultTextColor: string, DefaultTextSize: string) {
            Parameters.push(new HTMLEditor_Parameter(Category, "גופן", Prefix + "TextFont", "FontFamilyWithDefault", DefaultFontFamily));
            Parameters.push(new HTMLEditor_Parameter(Category, "צבע כתב", Prefix + "TextColor", "TextColor", DefaultTextColor));
            Parameters.push(new HTMLEditor_Parameter(Category, "גודל כתב", Prefix + "TextSize", "TextSize", DefaultTextSize));
        }
        static ParametersGroupNames_Text(Prefix) {
            return Prefix + "TextFont," + Prefix + "TextColor," + Prefix + "TextSize";
        }

        static ParametersGroup_MaxWidth(Parameters: Array<HTMLEditor_Parameter>, Category: string, Prefix: string) {
            Parameters.push(new HTMLEditor_Parameter(Category, "רוחב מקסימלי", Prefix + "MaxWidth", "MaxWidth", ""));
            Parameters.push(new HTMLEditor_Parameter(Category, "מיקום", Prefix + "MaxWidthAlignment", "MaxWidthAlignment", "right"));
        }
        static ParametersGroupNames_MaxWidth(Prefix) {
            return Prefix + "MaxWidth," + Prefix + "MaxWidthAlignment";
        }

        static ListTemplateParameters() {
            var Parameters = new Array<HTMLEditor_Parameter>();
            Parameters.push(new HTMLEditor_Parameter("כללי", "שוליים", "Padding", "Padding", "10"));
            Parameters.push(new HTMLEditor_Parameter("כללי", "רוחב פנימי", "BodyMaxWidth", "MaxWidth", ""));

            LandingPages.ParametersGroup_Background(Parameters, "רקע חיצוני", "", "#FFFFFF");
            LandingPages.ParametersGroup_Background(Parameters, "רקע פנימי", "Inner", "");
            
            LandingPages.ParametersGroup_Text(Parameters, "טקסט", "Body", "arial, helvetica, sans-serif", "#000000", "16");
            return Parameters;
        }

        static ListWidgetsDefinitions() {
            var ToReturn = new Array<HTMLEditor_Widget>();
            ToReturn.push(LandingPages.CreateWidget_Header());
            ToReturn.push(LandingPages.CreateWidget_Image());
            ToReturn.push(LandingPages.CreateWidget_Button());
            ToReturn.push(LandingPages.CreateWidget_Text());
            ToReturn.push(LandingPages.CreateWidget_TwoColumnWidgets());
            ToReturn.push(LandingPages.CreateWidget_ThreeColumnWidgets());
            ToReturn.push(LandingPages.CreateWidget_YouTube());
            ToReturn.push(LandingPages.CreateWidget_Social());
            ToReturn.push(LandingPages.CreateWidget_HTML());
            //ToReturn.push(LandingPages.CreateWidget_Entity());
            return ToReturn;
        }
        static CreateWidgetByName(Name): HTMLEditor_Widget {
            switch (Name) {
                case "Header":
                    return LandingPages.CreateWidget_Header();
                case "Image":
                    return LandingPages.CreateWidget_Image();
                case "Button":
                    return LandingPages.CreateWidget_Button();
                case "Text":
                    return LandingPages.CreateWidget_Text();
                case "TwoColumnWidgets":
                    return LandingPages.CreateWidget_TwoColumnWidgets();
                case "ThreeColumnWidgets":
                    return LandingPages.CreateWidget_ThreeColumnWidgets();
                case "YouTube":
                    return LandingPages.CreateWidget_YouTube();
                case "Social":
                    return LandingPages.CreateWidget_Social();
                case "HTML":
                    return LandingPages.CreateWidget_HTML();
                case "Entity":
                    return LandingPages.CreateWidget_Entity();
                default:
                    alert("Invalid Widget Name: " + Name);
                    break;
            }
        }

        static CreateWidget_Header() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Header";
            Widget.DisplayName = "כותרת";
            Widget.Template = '<div og-email-parameter="' + LandingPages.ParametersGroupNames_MaxWidth("") + '"><div style="text-align:center;" og-email-parameter="' + LandingPages.ParametersGroupNames_Background("") + ',' + LandingPages.ParametersGroupNames_Text("") + ',Padding,Text"></div></div>'
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן", "Text", "HTML", 'כותרת'));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "מרווח", "Padding", "Padding", "18"));
            LandingPages.ParametersGroup_Text(Widget.Parameters, "עיצוב - טקסט", "", "", "", "24");
            LandingPages.ParametersGroup_Background(Widget.Parameters, "עיצוב - רקע", "", "");
            LandingPages.ParametersGroup_MaxWidth(Widget.Parameters, "עיצוב - רוחב", "");
            return Widget;
        }
        static CreateWidget_Image() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Image";
            Widget.DisplayName = "תמונה";
            Widget.Template = '<div og-email-parameter="' + LandingPages.ParametersGroupNames_MaxWidth("") + '">'
                + '<div og-email-parameter="' + LandingPages.ParametersGroupNames_Background("") + ',TextAlignment,Padding">'
                + '<div class="htmleditor-editor-imagecontainer using-tooltip" title="החלפת תמונה" style="display:inline-block;" og-email-parameter="ImageWidth,ImageHeight"><a og-email-parameter="ImageHref" target="_blank"><img og-email-parameter="Image,AlternativeText,ImageWidth,ImageHeight" style="max-width:300px;"></a></div>'
                + '</div>'
                + '</div>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "תמונה", "Image", "Image", OfficeGuy.Common.FullRootURL + "/content/images/emailsubscriptions/image.jpg"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "טקסט חלופי", "AlternativeText", "AlternativeText", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "קישור", "ImageHref", "Href", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "מרווח", "Padding", "Padding", "18"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "מיקום", "TextAlignment", "TextAlignment", "center"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "רוחב תמונה מקסימלי", "ImageWidth", "ImageWidth", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "גובה תמונה מקסימלי", "ImageHeight", "ImageHeight", ""));
            LandingPages.ParametersGroup_Background(Widget.Parameters, "עיצוב - רקע", "", "");
            LandingPages.ParametersGroup_MaxWidth(Widget.Parameters, "עיצוב - רוחב", "");
            return Widget;
        }
        static CreateWidget_Button() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Button";
            Widget.DisplayName = "כפתור";
            Widget.Template = '<div og-email-parameter="' + LandingPages.ParametersGroupNames_MaxWidth("") + '">'
                + '<div style="text-align:center;" og-email-parameter="' + LandingPages.ParametersGroupNames_Background("") + ',Padding">'
                + '<a style="padding:10px;display:inline-block;text-decoration:none;text-align:center;min-width:200px;max-width:100%;" og-email-parameter="' + LandingPages.ParametersGroupNames_Text("") + ',TextColorHover,Text,ButtonBackgroundColor,ButtonBackgroundColorHover,Href,ButtonBorderRadius,ButtonShadow" class="og-button-ui-action" target="_blank">'
                + '</a>'
                + '</div>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "טקסט", "Text", "ButtonText", "לחץ/י כאן"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "קישור", "Href", "Href", "https://www.myofficeguy.com"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צבע רקע לכפתור", "ButtonBackgroundColor", "ButtonBackgroundColor", "#0091EA"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צבע רקע לכפתור במעבר עכבר", "ButtonBackgroundColorHover", "ButtonBackgroundColorHover", "#0071B7"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "רדיוס פינות מעוגלות", "ButtonBorderRadius", "BorderRadius", "4"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צל", "ButtonShadow", "BoxShadow", "2"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "מרווח", "Padding", "Padding", "18"));

            LandingPages.ParametersGroup_Text(Widget.Parameters, "עיצוב - טקסט", "", "", "#FFFFFF", "18");
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב - טקסט", "צבע כתב במעבר עכבר", "TextColorHover", "TextColorHover", "#FFFFFF"));

            LandingPages.ParametersGroup_Background(Widget.Parameters, "עיצוב - רקע", "", "");
            LandingPages.ParametersGroup_MaxWidth(Widget.Parameters, "עיצוב - רוחב", "");
            return Widget;
        }
        static CreateWidget_Text() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Text";
            Widget.DisplayName = "טקסט";
            Widget.Template = '<div og-email-parameter="' + LandingPages.ParametersGroupNames_MaxWidth("") + '"><div og-email-parameter="' + LandingPages.ParametersGroupNames_Background("") + ',' + LandingPages.ParametersGroupNames_Text("") + ',Padding,Text"></div></div>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("", "תוכן", "Text", "HTML", 'זהו רכיב טקסט פשוט. רכיב בסיסי שמאפשר להכניס מלל קצר או ארוך, שהוא פעמים רבות מרכז התוכן של המסר שאתם מעבירים.<div>אפשר <b>להדגיש</b> דברים מסוימים, <u>בצורות שונות</u>.</div><div style="text-align: center;">למרכז את הטקסט</div><div style="text-align: right;">וגם להוסיף <a href="https://www.myofficeguy.com">קישורים</a> בתוכו.</div></div>'));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "מרווח", "Padding", "Padding", "18"));
            LandingPages.ParametersGroup_Text(Widget.Parameters, "עיצוב - טקסט", "", "", "", "");
            LandingPages.ParametersGroup_Background(Widget.Parameters, "עיצוב - רקע", "", "");
            LandingPages.ParametersGroup_MaxWidth(Widget.Parameters, "עיצוב - רוחב", "");
            return Widget;
        }
        static CreateWidget_TwoColumnWidgets() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "TwoColumnWidgets";
            Widget.DisplayName = "רכיבים בשתי עמודות";

            Widget.Template =
                '<div og-email-parameter="' + LandingPages.ParametersGroupNames_MaxWidth("") + '">'
                + '<div style="width:50%;vertical-align:top;display:inline-block;" og-email-parameter="RightWidth">'
                + '<div class="htmleditor-widgetcontainer"></div>'
                + '</div>'
            + '<div style="width:50%;vertical-align:top;display:inline-block;" og-email-parameter="LeftWidth">'
                + '<div class="htmleditor-widgetcontainer"></div>'
                + '</div>'
                + '</div>';

            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Widgets = [[LandingPages.CreateWidget_Text()], [LandingPages.CreateWidget_Text()]];
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "רוחב עמודה ימנית", "RightWidth", "WidthPercent", "50"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "רוחב עמודה שמאלית", "LeftWidth", "WidthPercent", "50"));
            LandingPages.ParametersGroup_MaxWidth(Widget.Parameters, "עיצוב - רוחב", "");
            return Widget;
        }
        static CreateWidget_ThreeColumnWidgets() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "ThreeColumnWidgets";
            Widget.DisplayName = "רכיבים בשלוש עמודות";

            Widget.Template =
                '<div og-email-parameter="' + LandingPages.ParametersGroupNames_MaxWidth("") + '">'
                + '<div og-email-parameter="RightWidth" style="vertical-align:top;display:inline-block;">'
                + '<div class="htmleditor-widgetcontainer"></div>'
                + '</div>'
                + '<div og-email-parameter="CenterWidth" style="vertical-align:top;display:inline-block;">'
                + '<div class="htmleditor-widgetcontainer"></div>'
                + '</div>'
                + '<div og-email-parameter="LeftWidth" style="vertical-align:top;display:inline-block;">'
                + '<div class="htmleditor-widgetcontainer"></div>'
                + '</div>'
                + '</div>';

            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Widgets = [[LandingPages.CreateWidget_Text()], [LandingPages.CreateWidget_Text()], [LandingPages.CreateWidget_Text()]];
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "רוחב עמודה ימנית", "RightWidth", "WidthPercent", "33"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "רוחב עמודה אמצעית", "CenterWidth", "WidthPercent", "34"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "רוחב עמודה שמאלית", "LeftWidth", "WidthPercent", "33"));
            LandingPages.ParametersGroup_MaxWidth(Widget.Parameters, "עיצוב - רוחב", "");
            return Widget;
        }
        static CreateWidget_HTML() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "HTML";
            Widget.DisplayName = "קוד HTML";
            Widget.Template = '<div og-email-parameter="' + LandingPages.ParametersGroupNames_MaxWidth("") + '">'
                + '<div og-email-parameter="' + LandingPages.ParametersGroupNames_Background('') + ',Padding"><div og-email-parameter="HTML"></div>'
                + '</div>'
                + '</div>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("כללי", "תוכן HTML", "HTML", "CustomHTML", "<div style=\"padding:10px;\">כאן ניתן להזין קוד HTML משלכם. שימו לב, שימו ברכיב זה עלול לגרום לפגוע בתמיכה בתוכנות הדוא\"ל השונות.</div>"));
            LandingPages.ParametersGroup_Background(Widget.Parameters, "עיצוב - רקע", "", "");
            LandingPages.ParametersGroup_MaxWidth(Widget.Parameters, "עיצוב - רוחב", "");
            return Widget;
        }
        static CreateWidget_YouTube() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "YouTube";
            Widget.DisplayName = "סרטון ב-YouTube";
            Widget.Template = '<div og-email-parameter="' + LandingPages.ParametersGroupNames_MaxWidth("") + '">'
                + '<div style="text-align:center;" og-email-parameter="' + LandingPages.ParametersGroupNames_Background('') + ',Padding">'
                + '<div style="max-width:320px;max-height:180px;width:320px;height:180px;margin-left:auto;margin-right:auto;"><a og-email-parameter="YouTubeVideoID" target="_blank"><img width="320" height="180" og-email-parameter="YouTubeVideoID,AlternativeText"></a></div>'
                + '</div>'
                + '</div>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "קישור/מזהה סרטון ב-YouTube", "YouTubeVideoID", "YouTubeVideoID", "yF47119Wcr8"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "טקסט חלופי", "AlternativeText", "AlternativeText", "לחצו כאן לצפיה בסרטון"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "מרווח", "Padding", "Padding", "18"));
            LandingPages.ParametersGroup_Background(Widget.Parameters, "עיצוב - רקע", "", "");
            LandingPages.ParametersGroup_MaxWidth(Widget.Parameters, "עיצוב - רוחב", "");
            return Widget;
        }
        static CreateWidget_Entity() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Entity";
            Widget.DisplayName = "יצירת כרטיס";
            Widget.Template = '<div og-email-parameter="' + LandingPages.ParametersGroupNames_MaxWidth("") + '">'
                + '<div og-email-parameter="' + LandingPages.ParametersGroupNames_Background('') + ',EntityLayout,Padding,FontFamily">'
                + '<div class="Entity" og-email-parameter="Schema,EntityButtonText,EntityButtonColor,EntityButtonColorMouseover,EntityButtonBackground,EntityButtonBackgroundMouseover"><div style="text-align:center">יצירת כרטיס חדש. הכרטיס יופיע בדף הנחיתה.</div></div>'
                + '</div>'
                + '</div>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "תיקייה", "Schema", "Schema", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "כפתור שליחה", "EntityButtonText", "EntityButtonText", "שליחה"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "צבע כתב כפתור שליחה", "EntityButtonColor", "EntityButtonColor", "#FFFFFF"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "צבע כתב כפתור שליחה במעבר עכבר", "EntityButtonColorMouseover", "EntityButtonColorMouseover", "#FFFFFF"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "רקע כפתור שליחה", "EntityButtonBackground", "EntityButtonBackground", "#0091EA"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "רקע כפתור שליחה במעבר עכבר", "EntityButtonBackgroundMouseover", "EntityButtonBackgroundMouseover", "#0071B7"));
            //Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "תצוגה", "View", "View", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "גופן", "FontFamily", "FontFamily", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "אופן הצגת הכרטיס", "EntityLayout", "EntityLayout", "center"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "מרווח", "Padding", "Padding", "18"));
            LandingPages.ParametersGroup_Background(Widget.Parameters, "עיצוב - רקע", "", "");
            LandingPages.ParametersGroup_MaxWidth(Widget.Parameters, "עיצוב - רוחב", "");
            return Widget;
        }
        static CreateWidget_Social() {
            var Widget = new HTMLEditor_Widget();
            Widget.Name = "Social";
            Widget.DisplayName = "קישורים חברתיים";
            Widget.Template = '<div og-email-parameter="' + LandingPages.ParametersGroupNames_MaxWidth("") + '">'
                + '<div style="text-align:center;" og-email-parameter="Padding,BackgroundColor,TextColor,TextSize">'
                + '<a og-email-parameter="WebsiteURL,TextColor" target="_blank" style="padding-left:10px;padding-right:10px;"><span class=\"icon-globe\"></span></a>'
                + '<a og-email-parameter="FacebookURL,TextColor" target="_blank" style="padding-left:10px;padding-right:10px;"><span class=\"icon-facebook\"></span></a>'
                + '<a og-email-parameter="GooglePlusURL,TextColor" target="_blank" style="padding-left:10px;padding-right:10px;"><span class=\"icon-gplus-squared\"></span></a>'
                + '<a og-email-parameter="PinterestURL,TextColor" target="_blank" style="padding-left:10px;padding-right:10px;"><span class=\"icon-pinterest-squared\"></span></a>'
                + '<a og-email-parameter="YouTubeURL,TextColor" target="_blank" style="padding-left:10px;padding-right:10px;"><span class=\"icon-youtube-squared\"></span></a>'
                + '<a og-email-parameter="TwitterURL,TextColor" target="_blank" style="padding-left:10px;padding-right:10px;"><span class=\"icon-twitter-squared\"></span></a>'
                + '<a og-email-parameter="LinkedInURL,TextColor" target="_blank" style="padding-left:10px;padding-right:10px;"><span class=\"icon-linkedin-squared\"></span></a>'
                + '<a og-email-parameter="SkypeURL,TextColor" target="_blank" style="padding-left:10px;padding-right:10px;"><span class=\"icon-skype\"></span></a>'
                + '<a og-email-parameter="InstagramURL,TextColor" target="_blank" style="padding-left:10px;padding-right:10px;"><span class=\"icon-instagram\"></span></a>'
                + '</div>'
                + '</div>';
            Widget.Parameters = new Array<HTMLEditor_Parameter>();
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "אתר אינטרנט", "WebsiteURL", "HrefHidden", "https://www.myofficeguy.com"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Facebook", "FacebookURL", "HrefHidden", "https://www.facebook.com/SUMIT.co.il/"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Twitter", "TwitterURL", "HrefHidden", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "YouTube", "YouTubeURL", "HrefHidden", "https://www.youtube.com/channel/UC4tSTKkZVxcOMVSqpIJwJqQ"));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Pinterest", "PinterestURL", "HrefHidden", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Google Plus", "GooglePlusURL", "HrefHidden", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "LinkedIn", "LinkedInURL", "HrefHidden", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Skype", "SkypeURL", "HrefHidden", ""));
            Widget.Parameters.push(new HTMLEditor_Parameter("תוכן", "Instagram", "InstagramURL", "HrefHidden", ""));

            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צבע כתב", "TextColor", "TextColor", "#7d7d7d"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "גודל כתב", "TextSize", "TextSize", "60"));

            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "מרווח", "Padding", "Padding", "18"));
            Widget.Parameters.push(new HTMLEditor_Parameter("עיצוב", "צבע רקע", "BackgroundColor", "BackgroundColor", ""));

            LandingPages.ParametersGroup_MaxWidth(Widget.Parameters, "עיצוב - רוחב", "");

            return Widget;
        }
    }
}
